import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoginComponent} from "./login";
import {RegistrationComponent} from "./registration/registration.component";
import {RestorePasswordComponent} from "./restore-password/restore-password.component";
import {TmpNameRoutingModule} from "./tmpName-routing.module";
import {PasswordComponent} from "../../password/password.component";
import {PhoneComponent} from "../phone/phone.component";
import {ActivatedRoute} from "@angular/router";
import {FlashMessagesModule} from "angular2-flash-messages";
import {PhoneService} from "../phone/phone.service";
import {WelcomeMainComponent} from "./welcome-part.component";
import {ViewSettingService} from "../main-page/view-setting-service/view-setting.service";
import {ViewSettingResolver} from "../main-page/view-setting-service/view-setting.resolver";
import {SharedModule} from "../shared-module/shared.module";
import {PopupMessageModule} from "../_commonComp/popup-message/popup-message.module";

/**
 * Created by Rumyantsev Daniil on 06.09.2017.
 */

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TmpNameRoutingModule,
    FlashMessagesModule,
    ReactiveFormsModule,
    SharedModule,
    PopupMessageModule
  ],
  declarations: [
    LoginComponent,
    RegistrationComponent,
    RestorePasswordComponent,
    PasswordComponent,
    PhoneComponent,
    WelcomeMainComponent
  ],
  providers: [
    PhoneService,
    ViewSettingService,
    ViewSettingResolver,
  ]
})

export class TmpNameModule {
  constructor(private route: ActivatedRoute) {
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/tmpName.module.ts